module.exports = __webpack_public_path__ + "img/roll-679.bd8e72a1.png";